// extracted by mini-css-extract-plugin
module.exports = {"questionSelection":"RkXYkC-8RmR7riSq","floatingLabelWrapper":"_1HEq8s4OURoaE4l_","floatingLabel":"_1Bbe32SGuYWXx4Eo","error":"_1GBEAOqvBNzjrZRO","required":"_1oqcusrjpchHGtqG"};